"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bomSchema = exports.bomGroupSchema = exports.bomItemSchema = exports.articleSchema = void 0;
const z = require("zod");
exports.articleSchema = z.object({
    _id: z.number(),
    description: z.string(),
    price: z.number(),
    purchasePrice: z.number().nullable(),
    salesPrice: z.number().nullable(),
    unit: z.string(),
    category: z.string(),
    width: z.number().nullable(),
    depth: z.number().nullable(),
    type: z.string().nullable()
}).nonstrict();
exports.bomItemSchema = z.object({
    article: exports.articleSchema,
    amount: z.number(),
    totalPrice: z.number(),
    totalPurchasePrice: z.number(),
    totalSalesPrice: z.number()
});
exports.bomGroupSchema = z.object({
    description: z.string(),
    items: exports.bomItemSchema.array(),
    totalPrice: z.number(),
    totalPurchasePrice: z.number(),
    totalSalesPrice: z.number()
});
exports.bomSchema = z.object({
    groups: exports.bomGroupSchema.array(),
    totalPrice: z.number(),
    totalPurchasePrice: z.number(),
    totalSalesPrice: z.number()
});
//# sourceMappingURL=bom.js.map